import straightConnections from "./straightConnections"
let renders = {
    straight:straightConnections,
    default:straightConnections
}
export const connectionRenderRegister= function(name,renderer){
    renderers[name] = renderer
}
export default renders


// WEBPACK FOOTER //
// ./src/assets/tflow/render/connection/index.js